import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";

import ListSection from "components/ListSection";
import Advertisement from "./sections/Advertisement";
import IEKTalks from "./sections/IEKTalks";
// import PopularFigure from './sections/PopularFigure';

import netZero from "data/netZero";

import vw from "styles/utils";

import { getFeatureNews, getPopularArticle } from "utils/request";

function Sidebar() {
  const [featureNews, setFeatureNews] = useState({});
  const [popularArticle, setPopularArticle] = useState({});

  useEffect(() => {
    async function fetchData() {
      const featureNews = await getFeatureNews();
      const popularArticle = await getPopularArticle();

      setFeatureNews(featureNews);
      setPopularArticle(popularArticle);
    }
    fetchData();
  }, []);

  return (
    <Root>
      <StyledListSection
        title="精選新聞"
        iconImage={require("assets/images/icons/news.jpeg")}
        articles={featureNews.ArticleList}
        more="https://ieknet.iek.org.tw/ieknews/default.aspx?actiontype=ieknews&indu_idno=5"
      />
      <StyledListSection
        title="熱門點閱"
        iconImage={require("assets/images/icons/bulb.png")}
        articles={popularArticle.ArticleList}
        more="https://ieknet.iek.org.tw/iekrpt/default.aspx?currentPageIndex=1&domain=90&indu_idno=5&actiontype=rpt&sort=1&desc=0"
      />
      <StyledAdvertisement />
      <IEKTalks />
      <StyledListSection
        title="淨零知識庫 Free"
        iconImage={require("assets/images/icons/note.png")}
        articles={netZero}
        hideReadMore
      />
      <StyledListSection
        title="淨零知識庫 Free"
        iconImage={require("assets/images/icons/note.png")}
        articles={[]}
        hideReadMore
      />
      <StyledListSection
        title="淨零知識庫 Free"
        iconImage={require("assets/images/icons/note.png")}
        articles={[]}
        hideReadMore
      />
      {/* <PopularFigure /> */}
    </Root>
  );
}

const Root = styled.div`
  ${vw("margin-left", 0, 0, 30)}
`;

const StyledListSection = styled(ListSection)`
  ${vw("margin-bottom", 30)}
`;

const StyledAdvertisement = styled(Advertisement)`
  ${vw("margin-bottom", 30)}
`;

export default Sidebar;
